import { Assets } from '@air/api';
import { skipToken, useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';
import { centralizedClipAssetIdSelector, centralizedClipIdSelector } from '~/store/centralizedClip/selectors';
import { callAirApi } from '~/swr-hooks/callAirApi';

type VideoIntelligenceEnrichmentStatus = 'error' | 'empty' | 'complete';

type VideoIntelligenceStatus = {
  status: 'error' | 'processing' | 'complete' | 'none' | 'pending' | 'dispatched' | 'empty';
  updatedAt?: string;
  statuses?: {
    chapters?: VideoIntelligenceEnrichmentStatus;
    smartTags?: VideoIntelligenceEnrichmentStatus;
    summary?: VideoIntelligenceEnrichmentStatus;
  };
};

export const useGetVideoIntelligenceStatus = () => {
  const { currentWorkspace } = useCurrentWorkspace();
  const clipId = useSelector(centralizedClipIdSelector);
  const assetId = useSelector(centralizedClipAssetIdSelector);

  return useQuery({
    queryKey: ['VIDEO_INTELLIGENCE_STATUS', { clipId }],
    queryFn: currentWorkspace?.id
      ? async () =>
          callAirApi<VideoIntelligenceStatus>(() =>
            Assets.Versions.VideoIntelligence.Status.get({
              clipId,
              assetId,
              workspaceId: currentWorkspace.id,
            }),
          )
      : skipToken,
    enabled: !!currentWorkspace?.id && !!clipId && !!assetId,
  });
};
